export const BATCH_EDIT_DIALOG_LOCALE_ZHCHT = {
  title: 'æ¹éç·¨è¼¯',
  appendText: 'æ·»å æ°ç·¨è¼¯å',
  appendTextTip: 'æ·»å æ´å¤åé²è¡æ¹éæä½',
  okText: 'ç¢ºå®',
  cancelText: 'åæ¶',
  field: 'è«é¸æè¦ç·¨è¼¯çåï¼',
  fieldValue: 'è«è¼¸å¥è¦æ´æ¹çå¼ï¼',
  appendTips: 'æ·»å æ´å¤åé²è¡æ¹éæä½',
  selected: 'å·²é¸',
  row: 'è¡',
  confirmTitle: 'æç¤º',
  neverShow: 'ä¸åæç¤º',
  confirmText: 'å°ä¿®æ¹{0}è¡æ¸æï¼ç¢ºå®ä¿®æ¹åï¼'
};
